import { useContext } from 'react';

// auth provider
import { FacilityContext } from '../contexts/FacilityContext';
// import AuthContext from 'contexts/Auth0Context';
// import AuthContext from 'contexts/JWTContext';
// import AuthContext from 'contexts/AWSCognitoContext';

// ==============================|| AUTH HOOKS ||============================== //

const useFacility = () => {
    const context = useContext(FacilityContext);

    if (!context) throw new Error('context must be use inside provider');

    return context;
};

export default useFacility;
